(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["camera-product-tab-accordion"] && !Shopify.designMode) return;
  try {
    

// // Tab-with-accordion
// var $tabButtons = Array.prototype.slice.call(document.querySelectorAll('.js-tab-title'), 0);
// var $tabContent = Array.prototype.slice.call(document.querySelectorAll('.tab-content'), 0);

// // Check if there are any tabs on the page
// if ($tabButtons.length > 0) {

//   // Add a click event on each of them
//   $tabButtons.forEach(function ($el) {
//     $el.addEventListener('click', function () {
//       // Check if the button is already active
//       var isActive = $el.classList.contains('is-active');

//       // Remove active class from all buttons and content
//       $tabButtons.forEach(function ($button) {
//         $button.classList.remove("is-active");
//       });

//       $tabContent.forEach(function ($content) {
//         $content.classList.remove("is-active");
//       });

//       // Get the target from the clicked tab
//       var target = $el.dataset.target;
//       var $target = document.getElementById(target);

//       // Toggle the class on both the tab and the content targeted, only if the button was not already active
//       if (!isActive) {
//         $el.classList.toggle('is-active');
//         if ($target) {
//           $target.classList.toggle('is-active');
//         }
//       }

//     });
//   });
// }
// Tab-with-accordion
var $tabButtons = Array.prototype.slice.call(document.querySelectorAll('.js-tab-title'), 0);
var $tabContent = Array.prototype.slice.call(document.querySelectorAll('.tab-content'), 0);

// Function to close all tabs
function closeAllTabs() {
  $tabButtons.forEach(function ($button) {
    $button.classList.remove("is-active");
  });

  $tabContent.forEach(function ($content) {
    $content.classList.remove("is-active");
  });
}

// Function to handle tab click
function handleTabClick($el) {
  // Check if the button is already active
  var isActive = $el.classList.contains('is-active');

  // Close all tabs
  closeAllTabs();

  // Get the target from the clicked tab
  var target = $el.dataset.target;
  var $target = document.getElementById(target);

  // Toggle the class on both the tab and the content targeted, only if the button was not already active
  if (!isActive) {
    $el.classList.add('is-active');
    if ($target) {
      $target.classList.add('is-active');
    }
  }
}

// Check if there are any tabs on the page
if ($tabButtons.length > 0) {
  // Add a click event on each of them
  $tabButtons.forEach(function ($el, index) {
    $el.addEventListener('click', function () {
      // Check if the screen width is within the mobile range
      if (window.innerWidth <= 990) {
        // Close all tabs if it's the first tab and is already active in mobile view
        if (index === 0 && $el.classList.contains('is-active')) {
          closeAllTabs();
        } else {
          // Handle tab click for mobile
          handleTabClick($el);
        }
      } else {
        // Handle tab click for desktop
        handleTabClick($el);
      }
    });
  });
}
//    $(window).resize(function(){
//   if($(window).width() <= 990){
//     $('.is-active').removeClass('is-active');
//   }
// });    
  $(window).resize(function(){
  if($(window).width() <= 990){
    $('.is-active').removeClass('is-active');
  } else {
     $('[data-target="tab1"]').addClass('is-active');
     $('.description-tab-content').addClass('is-active');
  }
});


                          

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gps-navigator-tab-accordion"] && !Shopify.designMode) return;
  try {
    
// // Tab-with-accordion
// var $tabButtons = Array.prototype.slice.call(document.querySelectorAll('.js-tab-title'), 0);
// var $tabContent = Array.prototype.slice.call(document.querySelectorAll('.tab-content'), 0);

// // Function to close all tabs
// function closeAllTabs() {
//   $tabButtons.forEach(function ($button) {
//     $button.classList.remove("is-active");
//   });

//   $tabContent.forEach(function ($content) {
//     $content.classList.remove("is-active");
//   });
// }

// // Function to handle tab click
// function handleTabClick($el) {
//   // Check if the button is already active
//   var isActive = $el.classList.contains('is-active');

//   // Close all tabs
//   closeAllTabs();

//   // Get the target from the clicked tab
//   var target = $el.dataset.target;
//   var $target = document.getElementById(target);

//   // Toggle the class on both the tab and the content targeted, only if the button was not already active
//   if (!isActive) {
//     $el.classList.add('is-active');
//     if ($target) {
//       $target.classList.add('is-active');
//     }
//   }
// }

// // Check if there are any tabs on the page
// if ($tabButtons.length > 0) {
//   // Add a click event on each of them
//   $tabButtons.forEach(function ($el) {
//     $el.addEventListener('click', function () {
//       // Check if the screen width is within the mobile range
//       if (window.innerWidth <= 768) {
//         // Handle tab click for mobile
//         handleTabClick($el);
//       } else {
//         // Handle tab click for desktop
//         handleTabClick($el);
//       }
//     });
//   });
// }
// Tab-with-accordion
// var $tabButtons = Array.prototype.slice.call(document.querySelectorAll('.js-tab-title'), 0);
// var $tabContent = Array.prototype.slice.call(document.querySelectorAll('.tab-content'), 0);

// // Function to close all tabs
// function closeAllTabs() {
//   $tabButtons.forEach(function ($button) {
//     $button.classList.remove("is-active");
//   });

//   $tabContent.forEach(function ($content) {
//     $content.classList.remove("is-active");
//   });
// }

// // Function to handle tab click
// function handleTabClick($el) {
//   // Check if the button is already active
//   var isActive = $el.classList.contains('is-active');

//   // Close all tabs
//   closeAllTabs();

//   // Get the target from the clicked tab
//   var target = $el.dataset.target;
//   var $target = document.getElementById(target);

//   // Toggle the class on both the tab and the content targeted, only if the button was not already active
//   if (!isActive) {
//     $el.classList.add('is-active');
//     if ($target) {
//       $target.classList.add('is-active');
//     }
//   }
// }

// // Check if there are any tabs on the page
// if ($tabButtons.length > 0) {
//   // Add a click event on each of them
//   $tabButtons.forEach(function ($el, index) {
//     $el.addEventListener('click', function () {
//       // Check if the screen width is within the mobile range
//       if (window.innerWidth <= 990) {
//         // Close all tabs if it's the first tab and is already active in mobile view
//         if (index === 0 && $el.classList.contains('is-active')) {
//           closeAllTabs();
//         } else {
//           // Handle tab click for mobile
//           handleTabClick($el);
//         }
//       } else {
//         // Handle tab click for desktop
//         handleTabClick($el);
//       }
//     });
//   });
// }
  
// //    $(window).resize(function(){
// //   if($(window).width() <= 990){
// //     $('.is-active').removeClass('is-active');
// //   }
// // });    
//   $(window).resize(function(){
//   if($(window).width() <= 990){
//     $('.is-active').removeClass('is-active');
//   } else {
//      $('[data-target="tab1"]').addClass('is-active');
//      $('.description-tab-content').addClass('is-active');
//   }
// });
var $tabButtons = document.querySelectorAll('.js-tab-title');
var $tabContent = document.querySelectorAll('.tab-content');

function closeAllTabs() {
  $tabButtons.forEach(function ($button) {
    $button.classList.remove("is-active");
  });

  $tabContent.forEach(function ($content) {
    $content.classList.remove("is-active");
  });
}

function handleTabClick($el) {
  var isActive = $el.classList.contains('is-active');
  if (!isActive) {
    closeAllTabs();
    $el.classList.add('is-active');
    var target = $el.dataset.target;
    var $target = document.getElementById(target);
    if ($target) {
      $target.classList.add('is-active');
    }
  }
}

if ($tabButtons.length > 0) {
  $tabButtons.forEach(function ($el, index) {
    $el.addEventListener('click', function () {
      if (window.innerWidth <= 990) {
        if (index === 0 && $el.classList.contains('is-active')) {
          closeAllTabs();
        } else {
          handleTabClick($el);
        }
      } else {
        handleTabClick($el);
      }
    });
  });
}

window.addEventListener('resize', function () {
  if (window.innerWidth <= 990) {
    closeAllTabs();
  } else {
    var $defaultTab = document.querySelector('[data-target="tab1"]');
    if ($defaultTab) {
      $defaultTab.classList.add('is-active');
      var $defaultContent = document.querySelector('.description-tab-content');
      if ($defaultContent) {
        $defaultContent.classList.add('is-active');
      }
    }
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tab-accordion"] && !Shopify.designMode) return;
  try {
    
// // Tab-with-accordion
// var $tabButtons = Array.prototype.slice.call(document.querySelectorAll('.js-tab-title'), 0);
// var $tabContent = Array.prototype.slice.call(document.querySelectorAll('.tab-content'), 0);

// // Function to close all tabs
// function closeAllTabs() {
//   $tabButtons.forEach(function ($button) {
//     $button.classList.remove("is-active");
//   });

//   $tabContent.forEach(function ($content) {
//     $content.classList.remove("is-active");
//   });
// }

// // Function to handle tab click
// function handleTabClick($el) {
//   // Check if the button is already active
//   var isActive = $el.classList.contains('is-active');

//   // Close all tabs
//   closeAllTabs();

//   // Get the target from the clicked tab
//   var target = $el.dataset.target;
//   var $target = document.getElementById(target);

//   // Toggle the class on both the tab and the content targeted, only if the button was not already active
//   if (!isActive) {
//     $el.classList.add('is-active');
//     if ($target) {
//       $target.classList.add('is-active');
//     }
//   }
// }

// // Check if there are any tabs on the page
// if ($tabButtons.length > 0) {
//   // Add a click event on each of them
//   $tabButtons.forEach(function ($el) {
//     $el.addEventListener('click', function () {
//       // Check if the screen width is within the mobile range
//       if (window.innerWidth <= 768) {
//         // Handle tab click for mobile
//         handleTabClick($el);
//       } else {
//         // Handle tab click for desktop
//         handleTabClick($el);
//       }
//     });
//   });
// }
// Tab-with-accordion
// var $tabButtons = Array.prototype.slice.call(document.querySelectorAll('.js-tab-title'), 0);
// var $tabContent = Array.prototype.slice.call(document.querySelectorAll('.tab-content'), 0);

// // Function to close all tabs
// function closeAllTabs() {
//   $tabButtons.forEach(function ($button) {
//     $button.classList.remove("is-active");
//   });

//   $tabContent.forEach(function ($content) {
//     $content.classList.remove("is-active");
//   });
// }

// // Function to handle tab click
// function handleTabClick($el) {
//   // Check if the button is already active
//   var isActive = $el.classList.contains('is-active');

//   // Close all tabs
//   closeAllTabs();

//   // Get the target from the clicked tab
//   var target = $el.dataset.target;
//   var $target = document.getElementById(target);

//   // Toggle the class on both the tab and the content targeted, only if the button was not already active
//   if (!isActive) {
//     $el.classList.add('is-active');
//     if ($target) {
//       $target.classList.add('is-active');
//     }
//   }
// }

// // Check if there are any tabs on the page
// if ($tabButtons.length > 0) {
//   // Add a click event on each of them
//   $tabButtons.forEach(function ($el, index) {
//     $el.addEventListener('click', function () {
//       // Check if the screen width is within the mobile range
//       if (window.innerWidth <= 990) {
//         // Close all tabs if it's the first tab and is already active in mobile view
//         if (index === 0 && $el.classList.contains('is-active')) {
//           closeAllTabs();
//         } else {
//           // Handle tab click for mobile
//           handleTabClick($el);
//         }
//       } else {
//         // Handle tab click for desktop
//         handleTabClick($el);
//       }
//     });
//   });
// }
  
// //    $(window).resize(function(){
// //   if($(window).width() <= 990){
// //     $('.is-active').removeClass('is-active');
// //   }
// // });    
//   $(window).resize(function(){
//   if($(window).width() <= 990){
//     $('.is-active').removeClass('is-active');
//   } else {
//      $('[data-target="tab1"]').addClass('is-active');
//      $('.description-tab-content').addClass('is-active');
//   }
// });
var $tabButtons = document.querySelectorAll('.js-tab-title');
var $tabContent = document.querySelectorAll('.tab-content');

function closeAllTabs() {
  $tabButtons.forEach(function ($button) {
    $button.classList.remove("is-active");
  });

  $tabContent.forEach(function ($content) {
    $content.classList.remove("is-active");
  });
}

function handleTabClick($el) {
  var isActive = $el.classList.contains('is-active');
  if (!isActive) {
    closeAllTabs();
    $el.classList.add('is-active');
    var target = $el.dataset.target;
    var $target = document.getElementById(target);
    if ($target) {
      $target.classList.add('is-active');
    }
  }
}

if ($tabButtons.length > 0) {
  $tabButtons.forEach(function ($el, index) {
    $el.addEventListener('click', function () {
      if (window.innerWidth <= 990) {
        if (index === 0 && $el.classList.contains('is-active')) {
          closeAllTabs();
        } else {
          handleTabClick($el);
        }
      } else {
        handleTabClick($el);
      }
    });
  });
}

window.addEventListener('resize', function () {
  if (window.innerWidth <= 990) {
    closeAllTabs();
  } else {
    var $defaultTab = document.querySelector('[data-target="tab1"]');
    if ($defaultTab) {
      $defaultTab.classList.add('is-active');
      var $defaultContent = document.querySelector('.description-tab-content');
      if ($defaultContent) {
        $defaultContent.classList.add('is-active');
      }
    }
  }
});


  } catch(e) { console.error(e); }
})();
})();
